var _line, _mask, _rect, _mask2, _rect2, _mask3, _rect3, _line2, _line3, _circle, _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTest(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 515,
    height: 495,
    viewBox: "0 0 515 495",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 125,
    y1: 281.092,
    x2: 291,
    y2: 281.092,
    stroke: "black",
    strokeWidth: 16,
    strokeLinecap: "round"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1_153_22",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 159.092,
    width: 48,
    height: 48,
    rx: 8
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 159.092,
    width: 48,
    height: 48,
    rx: 8,
    fill: "#36D28F",
    stroke: "black",
    strokeWidth: 24,
    mask: "url(#path-2-inside-1_153_22)"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-2_153_22",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 241.092,
    width: 48,
    height: 48,
    rx: 8
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 241.092,
    width: 48,
    height: 48,
    rx: 8,
    fill: "#36D28F",
    stroke: "black",
    strokeWidth: 24,
    mask: "url(#path-3-inside-2_153_22)"
  })), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "path-4-inside-3_153_22",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 323.092,
    width: 48,
    height: 48,
    rx: 8
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 323.092,
    width: 48,
    height: 48,
    rx: 8,
    fill: "#36D28F",
    stroke: "black",
    strokeWidth: 24,
    mask: "url(#path-4-inside-3_153_22)"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 127,
    y1: 363.092,
    x2: 198,
    y2: 363.092,
    stroke: "black",
    strokeWidth: 16,
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 125,
    y1: 199.092,
    x2: 243,
    y2: 199.092,
    stroke: "black",
    strokeWidth: 16,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 282,
    cy: 199.092,
    r: 10,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M383.009 252.092C383.009 252.092 383.011 447.591 383.009 462.592C383.008 477.592 383.009 484.592 368.509 485.592C354.009 486.591 26.5093 485.592 26.5093 485.592C20.176 484.925 7.60933 480.092 8.00933 466.092V27.0917C7.84215 19.7584 15.5078 8.09137 25.5078 8.09174C35.5078 8.0921 363.008 8.09174 363.008 8.09174C370.008 7.42511 383.808 10.0919 383.008 26.0919V154.092",
    stroke: "black",
    strokeWidth: 16,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M122.018 55.2216V45.3518H154.2V55.2216H144.042V90.0923H132.06V55.2216H122.018ZM173.776 62.5183H190.136V72.2153H173.776V76.1133C173.776 76.9966 173.82 77.6878 173.91 78.1871C174.012 78.6863 174.211 79.1088 174.505 79.4544C174.8 79.7873 175.196 80.0113 175.696 80.1265C176.208 80.2417 176.899 80.2993 177.77 80.2993H190.904V89.7659C185.425 90.0603 181.111 90.2075 177.962 90.2075C176.528 90.2075 175.337 90.1883 174.39 90.1499C173.443 90.1115 172.348 90.0091 171.106 89.8427C169.878 89.6762 168.86 89.4394 168.053 89.1322C167.26 88.825 166.434 88.3833 165.576 87.8073C164.719 87.2312 164.047 86.5335 163.56 85.7142C163.074 84.895 162.67 83.8773 162.35 82.6611C162.03 81.4322 161.87 80.0305 161.87 78.4559V56.9114C161.87 55.3368 162.03 53.9415 162.35 52.7253C162.67 51.5092 163.074 50.4915 163.56 49.6722C164.047 48.853 164.719 48.1617 165.576 47.5984C166.447 47.0224 167.272 46.5871 168.053 46.2927C168.847 45.9855 169.865 45.7487 171.106 45.5822C172.361 45.4158 173.449 45.3198 174.371 45.2942C175.305 45.2558 176.502 45.2366 177.962 45.2366C182.34 45.2366 186.654 45.3582 190.904 45.6014V55.1256H177.77C176.093 55.1256 175.004 55.388 174.505 55.9129C174.019 56.4377 173.776 57.545 173.776 59.2348V62.5183ZM212.893 80.7025C214.839 80.7025 216.241 80.4209 217.098 79.8577C217.969 79.2816 218.404 78.3407 218.404 77.035C218.404 75.8829 217.994 74.9932 217.175 74.3659C216.356 73.7387 214.871 73.0858 212.72 72.4073C211.491 72.0233 210.403 71.652 209.456 71.2936C208.522 70.9224 207.587 70.4999 206.653 70.0263C205.718 69.5398 204.918 69.0406 204.252 68.5285C203.587 68.0037 202.959 67.3956 202.371 66.7043C201.782 66.0131 201.308 65.2642 200.95 64.4577C200.591 63.6512 200.31 62.7424 200.105 61.7311C199.913 60.7069 199.817 59.5868 199.817 58.3707C199.817 56.3481 200.053 54.5751 200.527 53.0518C201.001 51.5284 201.679 50.2483 202.563 49.2114C203.446 48.1745 204.572 47.336 205.942 46.6959C207.312 46.0559 208.835 45.595 210.512 45.3134C212.202 45.0318 214.141 44.891 216.33 44.891C218.763 44.891 221.208 45.0574 223.665 45.3902C226.123 45.723 228.287 46.1199 230.156 46.5807L229.061 55.6824C224.594 54.9144 221.073 54.5303 218.5 54.5303C217.86 54.5303 217.316 54.5431 216.868 54.5687C216.433 54.5815 215.921 54.6199 215.332 54.6839C214.756 54.748 214.276 54.8504 213.892 54.9912C213.52 55.132 213.149 55.3176 212.778 55.548C212.42 55.7657 212.151 56.0601 211.971 56.4313C211.805 56.7898 211.722 57.2122 211.722 57.6986C211.722 58.0059 211.747 58.2875 211.799 58.5435C211.863 58.7868 211.933 59.0108 212.01 59.2156C212.087 59.4204 212.221 59.6188 212.413 59.8109C212.605 59.9901 212.778 60.1437 212.932 60.2717C213.085 60.3997 213.328 60.5405 213.661 60.6941C214.007 60.8478 214.295 60.9758 214.525 61.0782C214.756 61.1678 215.121 61.2894 215.62 61.443C216.119 61.5838 216.529 61.699 216.849 61.7887C217.169 61.8783 217.655 62.0127 218.308 62.1919C220.689 62.832 222.661 63.5616 224.222 64.3809C225.797 65.2002 227.058 66.1923 228.005 67.3572C228.965 68.5221 229.644 69.8279 230.04 71.2744C230.437 72.7209 230.636 74.4619 230.636 76.4973C230.636 79.0448 230.258 81.2274 229.503 83.0452C228.76 84.863 227.64 86.3223 226.142 87.4232C224.645 88.5113 222.865 89.305 220.804 89.8043C218.743 90.3035 216.318 90.5531 213.527 90.5531C209.021 90.5531 204.374 90.0155 199.586 88.9402L200.758 79.5696C202.537 79.8513 204.604 80.1137 206.96 80.3569C209.315 80.5873 211.293 80.7025 212.893 80.7025ZM237.215 55.2216V45.3518H269.398V55.2216H259.24V90.0923H247.258V55.2216H237.215Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M342.461 312.5L298.461 282.5L269.961 367.5L342.461 312.5Z",
    fill: "#D8D8E4",
    stroke: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M419.965 94.5L298.465 278L345.465 310L468.465 126.5L419.965 94.5Z",
    fill: "#72D8FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M477.965 61.5C453.165 43.9 431.298 73.1667 423.465 90L472.465 123.5C504.465 90.3 489.465 68.3333 477.965 61.5Z",
    fill: "#FF5D5D",
    stroke: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M259.447 369.396C258.392 372.739 259.635 376.379 262.515 378.377C265.394 380.375 269.239 380.267 272.001 378.109L348.726 318.172C348.85 318.075 348.97 317.975 349.087 317.873C349.875 317.325 350.576 316.626 351.146 315.783L476.4 130.48L491.116 108.71C499.967 95.615 501.26 83.4436 498.207 73.3583C495.279 63.6852 488.65 56.9023 483.217 53.4595C483.105 53.3886 482.991 53.3205 482.876 53.2553C469.388 45.6193 457.625 45.8859 448.094 50.4815C439.206 54.767 433.311 62.3419 429.918 67.111C429.88 67.1633 429.844 67.2161 429.808 67.2693L414.768 89.52L289.838 274.342C289.363 275.045 289.015 275.795 288.788 276.567C288.693 276.793 288.609 277.023 288.534 277.259L259.447 369.396ZM300.565 292.298L330.207 312.335L282.465 349.631L300.565 292.298ZM455.043 64.8938C459.385 62.8001 465.55 61.8918 474.808 67.0742C477.597 68.8947 481.301 72.7332 482.893 77.9934C484.39 82.9391 484.34 90.1639 477.86 99.7499L467.58 114.958L432.548 91.7856L443.008 76.3111C446.143 71.9166 450.057 67.2976 455.043 64.8938ZM423.588 105.042L458.619 128.214L342.37 300.195L307.574 276.675L423.588 105.042Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTest);
export default __webpack_public_path__ + "static/media/Test.0d08fbfe1c61db7ad41ac0746e55c925.svg";
export { ForwardRef as ReactComponent };